/* jshint node:true */
'use strict';

var React       = require('react');
var classNames  = require('classnames');

var PlayerList = React.createClass({

    displayName: 'PlayerList',

    getInitialState: function () {
        return {
            homeAway: 'home',
            split: this.splitTabs()
        };
    },

    swapTeam: function(){
        if(this.state.homeAway === 'home'){
            this.setState({homeAway:'away'});
        }else{
            this.setState({homeAway:'home'});
        }
    },

    renderTeamList:function(aPlayers,sState){

        var iPlayerLen = aPlayers.length;
        var rPlayerList = {team:[],subs:[]};

        for (var i = 0; i < iPlayerLen; i++) {
            var oPlayer  = aPlayers[i];
            if(typeof oPlayer === 'undefined'){
                continue;
            }
            var props ={
                key:oPlayer.id,
                name:oPlayer.name,
                number:oPlayer.number,
                captain:oPlayer.captain,
                tries:oPlayer.tries,
                runs:oPlayer.runs,
                runMetres:oPlayer.runMetres,
                tackles:oPlayer.tackles,
                missedTackles:oPlayer.missedTackles,
                yellowCards:oPlayer.yellowCards,
                redCards:oPlayer.redCards,
                conversionGoals:oPlayer.conversionGoals,
                matchState:sState,
                position:oPlayer.position,
                subbed:oPlayer.subbed,
                penalties:oPlayer.penalties,
                events:oPlayer.events,
                subTip:oPlayer.subTip
            };

            if(i <= 14){
                rPlayerList.team.push(
                    <PlayerListRow {...props} />
                );
            }else{
                rPlayerList.subs.push(
                    <PlayerListRow {...props} />
                );
            }
        }

        return rPlayerList;
    },

    splitTabs:function(){
        var iWindowWidth = this.props.width || 1280;
        if(iWindowWidth > 1280){
            return true;
        }else{
            return false;
        }
    },

    render: function () {

        /* confusing names of vars to enable showing and hiding of tabs, to be tidied up. */

        var sState          = this.props.matchState || 'pre'; //pre,post,live
        var aHomeTeam       = this.props.homeTeam || [];
        var aAwayTeam       = this.props.awayTeam || [];

        if(aHomeTeam.length <= 0 && aAwayTeam.length <= 0 ){
            //return (
             //   <div class="no-standings" style={{padding:'20px',textAlign:'center'}}>Line-ups not yet available</div>
            //);
        }

        var bForceSplit     = this.props.split || false;
        var bSplit          = this.state.split || false;
        var oHome           = this.props.home || {};
        var oAway           = this.props.away || {};

        var aArticleClass   = ['boxscore-tabs','sub-module-mobile-combine-split','combined'];
        var aButtonHome     = ['button-filter-alt','lg','fixed'];
        var aButtonAway     = ['button-filter-alt','lg','fixed'];

        var aPlayerList = {
            home:{team:[],subs:[]},
            away:{team:[],subs:[]}
        };

        if(!bForceSplit){
            aArticleClass.push('combined');
        }

        aPlayerList = {
            home:this.renderTeamList(aHomeTeam,sState),
            away:this.renderTeamList(aAwayTeam,sState)
        };

        if(this.state.homeAway === 'home'){
            aButtonHome.push('active');
        }else{
            aButtonAway.push('active');
        }

        var aHomeStyle = {display:'block'};
        var aAwayStyle = {display:'block'};
        if(!bSplit || !bForceSplit){
            if(this.state.homeAway === 'home'){
                aAwayStyle = {display:'none'};
            }else{
                aHomeStyle = {display:'none'};
            }
        }

        var sArticleClass   = classNames(aArticleClass);
        var sButtonHome     = classNames(aButtonHome);
        var sButtonAway     = classNames(aButtonAway);
        var sHomeAbbr       = oHome.abbreviation || oHome.name;
        var sAwayAbbr       = oAway.abbreviation || oAway.name;
        sHomeAbbr           = sHomeAbbr.toUpperCase();
        sAwayAbbr           = sAwayAbbr.toUpperCase();
        var rTableHeader    = null;

        if(sState === 'pre'){
            rTableHeader = (
                <tr>
					<th className="number" style={{width:'33px'}}>No.</th>
					<th className="name" colSpan="2">Name</th>
				</tr>
            );
        }else{
            rTableHeader = (
                <tr>
					<th style={{width:'33px'}}></th>
					<th className="number">No.</th>
					<th className="name">Name</th>
				</tr>
            );
        }

        if(aPlayerList.home.team.length <= 0){
            aPlayerList.home.team.push((
                <tr key="noHome">
                    <td colSpan="3" style={{padding:'20px',textAlign:'center'}}>Line-ups not yet available</td>
                </tr>
            ));
        }

        if(aPlayerList.away.team.length <= 0){
            aPlayerList.away.team.push((
                <tr key="noAway">
                    <td colSpan="3" style={{padding:'20px',textAlign:'center'}}>Line-ups not yet available</td>
                </tr>
            ));
        }

        return (
            <article className={sArticleClass} data-behavior="content_tab_mobile">
            	<header>
                    <div className="filter form-group button-group">
                        <button className={sButtonHome} onClick={this.swapTeam}><span className="team-name">{oHome.name}</span><span className="team-name-short">{sHomeAbbr}</span></button>
                        <button className={sButtonAway} onClick={this.swapTeam}><span className="team-name">{oAway.name}</span><span className="team-name-short">{sAwayAbbr}</span></button>
                    </div>
            	</header>
        		<div className="row-wrapper">
        			<div className="content-tab" style={aHomeStyle}>
        				<div className="col column-one">
        					<div className="sub-module rugby">
        						<div className="content">
        							<table data-behavior="table_accordion" className="table-accordion">
        								<caption><img src={oHome.logo} />{oHome.name}</caption>
        								<thead>
        									{rTableHeader}
        								</thead>
        								<tbody>
        								    {aPlayerList.home.team}
        								</tbody>
        								<thead>
        									<tr className="secondTableHeader">
        										<th colSpan="3">Replacements</th>
        									</tr>
        								</thead>
        								<tbody>
        								    {aPlayerList.home.subs}
        								</tbody>
        							</table>
        						</div>
        					</div>
        				</div>
        			</div>
        			<div className="content-tab" style={aAwayStyle}>
            			<div className="col column-two">
        					<div className="sub-module rugby">
        						<div className="content">
        							<table data-behavior="table_accordion" className="table-accordion">
        								<caption><img src={oAway.logo} />{oAway.name}</caption>
        								<thead>
        									{rTableHeader}
        								</thead>
        								<tbody>
        								    {aPlayerList.away.team}
        								</tbody>
        								<thead>
        									<tr className="secondTableHeader">
        										<th colSpan="3">Replacements</th>
        									</tr>
        								</thead>
        								<tbody>
        								    {aPlayerList.away.subs}
        								</tbody>
        							</table>
        						</div>
        					</div>
        				</div>
        			</div>
        		</div>
            </article>
        );

    }
});

var PlayerListRow = React.createClass({

    displayName: 'PlayerListRow',

    getInitialState: function () {
        return {
            expanded: false
        };
    },

    expandRow: function(){
        if(this.state.expanded){
            this.setState({expanded:false});
        }else{
            this.setState({expanded:true});
        }
    },

    renderIcons: function(){

        var hEvents       = this.props.events || {};
        var hIconCode   = {
            1:'T',
            2:'&#xE09F;',
            3:'&#xE0A0;',
            4:'&#xE097;',
            5:'',
            6:''
        };
        var aIcons = [];

        //Loop tooltips
        for (var iEventId in hEvents) {
            if (hEvents.hasOwnProperty(iEventId)) {
                var iElQuant = hEvents[iEventId].length;
                var sToolTipTxt = '('+hEvents[iEventId].join(',')+')';
                if(iElQuant >= 1){

                    var sClassStr = "icon-font rugby-icon";
                    if(iEventId == 5){
                        sClassStr = "game-icon icon-font-before icon-soccer-card02-solid-before icon-yellowcard";
                    }else if(iEventId == 6){
                        sClassStr = "game-icon icon-font-before icon-soccer-card02-solid-before icon-redcard";
                    }

                    var sKey = "icon."+iEventId;
                    var sSubKey = "icon.sub."+iEventId;
                    aIcons.push((
                        <div key={sKey} className="tooltip" data-tooltip={sToolTipTxt}><span className={sClassStr} dangerouslySetInnerHTML={{__html:hIconCode[iEventId]}}></span></div>
                    ));
                    if(iElQuant > 1){
                        aIcons.push((
                            <span key={sSubKey} className="subscript">{iElQuant}</span>
                        ));
                    }
                }
            }
        }

        return aIcons;
    },

    render: function () {

        var sName           = this.props.name || '-';
        var bCaptain        = this.props.captain || false;
        var iNumber         = this.props.number || '-';
        var iTries          = this.props.tries || 0;
        var iRuns           = this.props.runs || 0;
        var iRunMetres      = this.props.runMetres || 0;
        var iTackles        = this.props.tackles|| 0;
        var iMissedTackles  = this.props.missedTackles || 0;
        var iYellowCards    = this.props.yellowCards || 0;
        var iRedCards       = this.props.redCards || 0;
        var iConversionGoals= this.props.conversionGoals || 0;
        var iPenGoals       = this.props.penalties || 0;
        var sPosition       = this.props.position || '';
        var bSubbed         = this.props.subbed || false;
        var hToolTips       = this.props.tooltips || {};
        var sSubTip         = this.props.subTip || '';
        var sState          = this.props.matchState || 'pre'; //pre,post,live
        var iTotalTackles   = parseInt(iTackles)+parseInt(iMissedTackles);

        var rStatsHtml      = null;
        var oBarBackground  = {backgroundColor:'#f2f2f2'};
        var oTackles        = {backgroundColor:'#dd2126',width:'0%'};
        var oTacklesMissed  = {backgroundColor:'#dd2126',width:'0%'};
        var aRowClass       = [];
        var aAccoClass      = ['accordion-content'];
        var aAccoBtnClass   = ['icon-accordion','btn-accordion'];

        if(sPosition && sPosition !== 'UKN'){
            sName += ', '+sPosition;
        }

        if(bCaptain){
            sName += ' (c)';
        }

        if(this.state.expanded){
            aAccoClass.push('open');
            aRowClass.push('active');
            aAccoBtnClass.push('active');
            var sAccoClass = classNames(aAccoClass);

            var iTacklesPerc = parseInt((iTackles/iTotalTackles)*100);
            oTackles.width = iTacklesPerc+'%';
            var iMissedPerc = parseInt((iMissedTackles/iTotalTackles)*100);
            oTacklesMissed.width = iMissedPerc+'%';

            rStatsHtml = (
                <div className={sAccoClass}>
                    <div className="lineup-stats">
                        <ul className="stats">
                            <li className="stat">
                                <span className="label">Tries</span>
                                <span className="value">{iTries}</span>
                            </li>
                            <li className="stat">
                                <span className="label">Runs</span>
                                <span className="value">{iRuns}</span>
                            </li>
                            <li className="stat">
                                <span className="label">Run Metres</span>
                                <span className="value">{iRunMetres}</span>
                            </li>
                        </ul>
                        <div className="fouls">
                            <ul className="compareLineGraph sameTeam">
                                <li>
                                    <span className="chartLabel">Tackles</span>
                                    <span style={oBarBackground} className="bar-total">
                                        <span style={oTackles} className="bar-percentage"></span>
                                    </span>
                                    <span className="chartValue">{iTackles}</span>
                                </li>
                                <li>
                                    <span style={oBarBackground} className="bar-total">
                                        <span style={oTacklesMissed} className="bar-percentage"></span>
                                    </span>
                                    <span className="chartValue">{iMissedTackles}</span>
                                    <span className="chartLabel">Missed Tackles</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )
        }
        var sRowClass = classNames(aRowClass);
        var sAccoBtnClass = classNames(aAccoBtnClass);

        var hNameStyleHack = {
            whiteSpace:'nowrap',
            overflow:'hidden',
            textOverflow:'ellipsis'
        };

        if(sState === 'pre'){
            return (
                <tr className={sRowClass}>
                    <td className="number">{iNumber}</td>
                    <td colSpan="2" className="date" style={hNameStyleHack}>{sName}</td>
                </tr>
            );
        }else{

            var aIcons = this.renderIcons() || [];

            var rSubbed = null;
            if(bSubbed){
                rSubbed = (
                    <div key="icon.subbed" className="tooltip" data-tooltip={sSubTip}><span className="icon-font icon-soccer-substitution-before"></span></div>
                )
            }

            return (
                <tr className={sRowClass}>
                    <td colSpan="3" className={sRowClass}>
                        <div className="accordion-item ">
                            <div className="accordion-header lineup-player" onClick={this.expandRow}>
                                <span key="btn" className={sAccoBtnClass}></span>
                                {rSubbed}
                                <span key="no" className="number">{iNumber}</span>
                                <span key="name"><span className="name" style={hNameStyleHack}>{sName}</span>{aIcons}</span>
                            </div>
                            {rStatsHtml}
                        </div>
                    </td>
                </tr>
            );
        }

    }
});

module.exports = PlayerList;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/PlayerList.jsx
 **/